import axios, { AxiosResponse } from "axios";
import { WebAPI, IFailCallbackParam } from "../constants";
import { getErrorStatus } from "./getErrorStatus";
import AuthService from "../../common/AuthService";

interface ICallbackParams extends IFailCallbackParam {
  /**
   * WebAPIからモデル学習プログラムRev番号の取得が成功した場合に呼び出されます
   * @callback success
   * @param {IGetRevisionResponceModel} revision - Rev番号の配列
   * @param {number} status - httpステータス
   */
  success: (revision: IGetRevisionResponceModel, status: number) => void;
}

export interface IGetRevisionResponceModel {
  /**
   * Rev番号一覧
   * 配列の中に複数の要素が無くてもオブジェクト内に要素があるので使用する
   */
  revision: string[];
}

function AxiosGet(url: string, token?: string) {
  if (token) {
    return axios.get(url, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });
  } else {
    return axios.get(url);
  }
}

interface IAxiosInternalParams extends ICallbackParams {
  promise: Promise<AxiosResponse>;
}

function AxiosInternal(params: IAxiosInternalParams) {
  params.promise
    .then((res) => {
      const data: IGetRevisionResponceModel = res.data;
      params.success(data, res.status);
    })
    .catch((err) => {
      const { id, status } = getErrorStatus(err);
      params.fail(id, status);
    });
}

export interface IGetRevisionParams extends ICallbackParams {
  /**
   * 認証オブジェクト
   */
  authService?: AuthService;
}

/**
 * Rev番号を取得します
 * @function getRevision
 * @param {IGetRevisionParams} params - Rev番号取得パラメータ
 */
export function getRevision(params: IGetRevisionParams): void {
  const { authService } = params;
  const url = WebAPI.GETREV_MODEL;
  if (authService) {
    authService.getToken({
      success: (token) => {
        AxiosInternal({
          promise: AxiosGet(url, token),
          success: params.success,
          fail: (id, status) => {
            if (status === 401) {
              getRevisionRetry401(authService, url, params);
            } else {
              params.fail(id, status);
            }
          },
        });
      },
      fail: (err) => {
        const { id, status } = getErrorStatus(err);
        params.fail(id, status);
      },
    });
  } else {
    AxiosInternal({
      promise: AxiosGet(url),
      success: params.success,
      fail: params.fail
    });
  }
}

/**
 * Rev番号を取得します
 * @function getRevisionRetry401
 * @param {AuthService} authService - 認証オブジェクト
 * @param {string} url - リクエストURL
 * @param {ICallbackParams} params - コールバックパラメータ
 */
function getRevisionRetry401(
  authService: AuthService,
  url: string,
  params: ICallbackParams
): void {
  authService.updateToken({
    success: (token) => {
      AxiosInternal({
        promise: AxiosGet(url, token),
        success: params.success,
        fail: params.fail,
      });
    },
    fail: (err) => {
      const { id, status } = getErrorStatus(err);
      params.fail(id, status);
    },
  });
}